import { useEffect } from 'react';
import { Toaster } from "sonner";

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useStore } from './store/useStore';
import { useDirection } from './hooks/useDirection';
import Layout from './components/layout/Layout';
import { Navigate } from 'react-router-dom';
// Pages
import Landing from './pages/landing/Landing';
import Sectors from './pages/Sectors';
import SectorDetail from './pages/companyDetails/SectorDetail';
import Careers from './pages/Careers';
import JobDetail from './pages/JobDetail';
import Contact from './pages/Contact';
import './i18n';
import Guide from './pages/Guide';
import Gallery from './pages/GallerySection';
import AdminLogin from './pages/AdminLogin';
import ProtectedRoute from './pages/ProtectedRoute ';
import AdminDashboard from './pages/Dashboard/AdminDashboard';
import AboutDetails from './pages/AboutDetails';
import Investors from './pages/investors/Investors'
function App() {
  const { setSeedData } = useStore();
  const direction = useDirection();

  useEffect(() => {
    // Load seed data
    const loadSeedData = async () => {
      try {
        const response = await fetch('/data/seed.json');
        const data = await response.json();
        setSeedData(data);
      } catch (error) {
        console.error('Failed to load seed data:', error);
      }
    };

    loadSeedData();
  }, [setSeedData]);

  return (
    <Router>
      <Layout>
         <Toaster
          position="top-right"
          richColors
          toastOptions={{
            duration: 4000,
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/sectors" element={<Sectors />} />
          <Route path="/sectors/:id" element={<SectorDetail />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/:id" element={<JobDetail />} />
          <Route path="/investors" element={<Investors/>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery/>} />
          <Route path="/about" element={<AboutDetails/>} />
          <Route path="/guide" element={<Guide/>} />


          
          <Route path="/admin/login" element={<AdminLogin/>} />
           <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;